{
  "nav": {
    "mainNavigation": "التنقل الرئيسي",
    "messages": "الرسائل",
    "templates": "القوالب",
    "connectedSystems": "الأنظمة المرتبطة",
    "sectionSettings": "الإعدادات",
    "settings": "الإعدادات",
    "users": "المستخدمين",
    "groups": "المجموعات",
    "changeBranch": "تغيير الفرع",
    "systems": "الأنظمة",
    "toggleSidebarHint": "تبديل الشريط الجانبي"
  },
  "sidebar": {
    "toggle": "تبديل الشريط الجانبي",
    "toggleHint": "إظهار أو إخفاء القائمة",
    "title": "القائمة الجانبية",
    "description": "التنقل بين صفحات النظام"
  },
  "brand": "المسافر"
}
